import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { Checkbox } from "primereact/checkbox";
import { getLocale } from "../utility/service/tool-service";
import { useTranslation, Trans } from "react-i18next";
import main from "../assets/images/InventoryPlanFlow/main.png";
import icon from "../assets/images/InventoryPlanFlow/icon.png";
import pop1 from "../assets/images/InventoryPlanFlow/pop1.png";
import pop2 from "../assets/images/InventoryPlanFlow/pop2.png";
import pop3 from "../assets/images/InventoryPlanFlow/pop3.png";
import pop4 from "../assets/images/InventoryPlanFlow/pop4.png";
import pop5 from "../assets/images/InventoryPlanFlow/pop5.png";
import pop6 from "../assets/images/InventoryPlanFlow/pop6.png";
import pop7 from "../assets/images/InventoryPlanFlow/pop7.png";
import pop8 from "../assets/images/InventoryPlanFlow/pop8.png";

const ImageLocaleModal = ({ visible, onHide, title = "", checked = false, onDontShowAgain, step = 0 }) => {
  const { t } = useTranslation();
  const [dontShowAgain, setDontShowAgain] = useState(checked);

  // 如果外部 checked 有變化，就同步進來
  useEffect(() => {
    setDontShowAgain(checked);
  }, [checked]);

  const getZIndex = (item, step) => {
    if (item.src === icon) return 999;
    if (item.index !== -1 && step >= item.index) return 999;
    // return item.zindex;
    return 1;
  };

  const renderContent = (step) => {
    const images = [
      {
        src: main,
        index: -1,
        zindex: 0,
        label: t("inventoryPlanFlow.main.lable"),
        labelColor: "#5a5758",
        labelSize: "1.2rem",
        subtitle: t("inventoryPlanFlow.main.subtitle"),
        subtitleSize: "0.9rem",
        left: "37.5%",
        top: "56%",
        textAlign: "center",
        transform: "translate(-50%, -50%)",
      },
      {
        src: icon,
        index: -1,
        zindex: 0,
        label: t("inventoryPlanFlow.main.lable"),
        labelColor: "#5a5758",
        labelSize: "1.2rem",
        subtitle: t("inventoryPlanFlow.main.subtitle"),
        subtitleSize: "0.9rem",
        left: "37.5%",
        top: "56%",
        textAlign: "center",
        transform: "translate(-50%, -50%)",
      },
      {
        src: pop1,
        index: 0,
        zindex: 1,
        label: t("inventoryPlanFlow.pop1.lable"),
        labelColor: "#798a8e",
        subtitle: t("inventoryPlanFlow.pop1.subtitle"),
        left: "64%",
        top: "18%",
        textAlign: "left",
        borderLeft: true,
      },
      {
        src: pop2,
        index: 1,
        zindex: 2,
        label: t("inventoryPlanFlow.pop2.lable"),
        labelColor: "#7aac31",
        subtitle: t("inventoryPlanFlow.pop2.subtitle"),
        left: "74.5%",
        top: "36.5%",
        textAlign: "left",
        borderLeft: true,
      },
      {
        src: pop3,
        index: 2,
        zindex: 3,
        label: t("inventoryPlanFlow.pop3.lable"),
        labelColor: "#7aac31",
        subtitle: t("inventoryPlanFlow.pop3.subtitle"),
        left: "74.5%",
        top: "61%",
        textAlign: "left",
        borderLeft: true,
      },
      {
        src: pop4,
        index: 3,
        zindex: 4,
        label: t("inventoryPlanFlow.pop4.lable"),
        labelColor: "#7aac31",
        subtitle: t("inventoryPlanFlow.pop4.subtitle"),
        left: "64%",
        top: "79%",
        textAlign: "left",
        borderLeft: true,
      },
      {
        src: pop5,
        index: 4,
        zindex: 5,
        label: t("inventoryPlanFlow.pop5.lable"),
        labelColor: "#7aac31",
        subtitle: t("inventoryPlanFlow.pop5.subtitle"),
        right: "65%",
        top: "79%",
        textAlign: "right",
        borderRight: true,
      },
      {
        src: pop6,
        index: 5,
        zindex: 6,
        label: t("inventoryPlanFlow.pop6.lable"),
        labelColor: "#7aac31",
        subtitle: t("inventoryPlanFlow.pop6.subtitle"),
        right: "74.5%",
        top: "61%",
        textAlign: "right",
        borderRight: true,
      },
      {
        src: pop7,
        index: 6,
        zindex: 7,
        label: t("inventoryPlanFlow.pop7.lable"),
        labelColor: "#5cc9cc",
        subtitle: t("inventoryPlanFlow.pop7.subtitle"),
        right: "74.5%",
        top: "36.5%",
        textAlign: "right",
        borderRight: true,
      },
      {
        src: pop8,
        index: 7,
        zindex: 8,
        label: t("inventoryPlanFlow.pop8.lable"),
        labelColor: "#326d9f",
        subtitle: t("inventoryPlanFlow.pop8.subtitle"),
        right: "64%",
        top: "18%",
        textAlign: "right",
        borderRight: true,
      },
    ];
    return (
      <div className="relative w-full h-full">
        <span className="font-bold inventory-flow-modal-lable">
          <Trans i18nKey="inventoryPlanFlow.lable" components={[<span className="inventory-flow-underline-yellow" />]}>
            {t("inventoryPlanFlow.lable")}
          </Trans>
        </span>

        {images.map((item, index) => (
          <React.Fragment key={index}>
            <img
              src={item.src}
              alt={`圖片 ${index}`}
              className="absolute top-0 left-0 w-full h-full object-contain"
              style={{
                objectFit: "contain",
                zIndex: getZIndex(item, step),
              }}
            />
            <div
              className="absolute"
              style={{
                left: item.left,
                top: item.top,
                right: item.right,
                zIndex: getZIndex(item, step),
                textAlign: item.textAlign,
                borderRight: `${item.borderRight ? `2px solid ${item.labelColor}` : ""} `,
                borderLeft: `${item.borderLeft ? `2px solid ${item.labelColor}` : ""} `,
                paddingRight: `${item.borderRight ? `8px` : ""} `,
                paddingLeft: `${item.borderLeft ? `8px` : ""} `,
              }}
            >
              <span
                className="inventory-flow-modal-content-label"
                style={{
                  color: item.labelColor,
                  fontSize: item.labelSize || "1.1rem",
                }}
              >
                {item.label}
              </span>
              <br />
              <span
                className="inventory-flow-modal-content-subtitle"
                style={{
                  "--subtitle-size": item.subtitleSize,
                }}
              >
                {item.subtitle}
              </span>
            </div>
          </React.Fragment>
        ))}

        {/* 半透明遮罩 */}
        {step >= 0 && <div className="inventory-flow-modal-overlay" style={{ zIndex: 100 }} />}
      </div>
    );
  };

  const footer = (
    <div className="flex justify-content-between align-items-center">
      <div className="flex align-items-center">
        <Checkbox inputId="dontShowAgain" checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.checked)} />
        <label htmlFor="dontShowAgain" className="ml-2 cursor-pointer">
          {t("dontShowAgain")}
        </label>
      </div>
      <Button
        label={t("button.close")}
        icon="pi pi-times"
        onClick={() => {
          // 把目前的 dontShowAgain 狀態傳給外部
          if (onDontShowAgain) {
            onDontShowAgain(dontShowAgain);
          }
          onHide();
        }}
        className="p-button-text"
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t("inventoryPlanFlow.title")}
      footer={footer}
      // style={{ width: "60%", height: "70vh", maxWidth: "920px", maxHeight: "700px" }} // 這裡加上高度
      style={{ width: "90%", height: "80vh", maxWidth: "920px", maxHeight: "700px" }}
      contentStyle={{ padding: 0, height: "100%" }}
      closeOnEscape={true}
      maximizable={false}
      closable={false}
      draggable={false}
    >
      <div
        style={{
          width: "900px", // 固定內容寬度 (設計稿大小)
          height: "550px", // 固定內容高度
        }}
      >
        {renderContent(step)}
      </div>
    </Dialog>
  );
};

// const ImageLocaleModal = ({
//   visible,
//   onHide,
//   baseImagePath,
//   title = "",
//   width = "60%",
//   checked = false,
//   onDontShowAgain,
// }) => {
//   const { t } = useTranslation();
//   const [imagePath, setImagePath] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [dontShowAgain, setDontShowAgain] = useState(checked);

//   // 如果外部 checked 有變化，就同步進來
//   useEffect(() => {
//     setDontShowAgain(checked);
//   }, [checked]);

//   // 獲取當前語系
//   const getCurrentLocale = () => {
//     const locale = getLocale();
//     if (!locale) return 'en';
//     // 轉換為小寫
//     const lowerLocale = locale.toLowerCase();

//     return lowerLocale;
//   };

//   // 獲取語系後綴
//   const getLocaleSuffix = (locale) => {

//     // 簡化的語系對應
//     if (locale.includes('zh') || locale.includes('tw')) {
//       return 'tw';
//     } else if (locale.includes('vi')) {
//       return 'vi';
//     } else {
//       return 'en';
//     }
//   };

//   // 載入圖片
//   useEffect(() => {

//     if (visible && baseImagePath) {
//       setIsLoading(true);
//       setError(null);

//       const currentLocale = getCurrentLocale();
//       const localeSuffix = getLocaleSuffix(currentLocale);
//       const path = `${process.env.PUBLIC_URL}${baseImagePath}_${localeSuffix}.png`;

//       const img = new Image();
//       img.onload = () => {
//         setImagePath(path);
//         setIsLoading(false);
//       };
//       img.onerror = () => {
//         // 如果當前語系圖片不存在，嘗試載入英文版本
//         const fallbackPath = `${process.env.PUBLIC_URL}${baseImagePath}_en.png`;

//         const fallbackImg = new Image();
//         fallbackImg.onload = () => {
//           setImagePath(fallbackPath);
//           setIsLoading(false);
//         };
//         fallbackImg.onerror = () => {
//           setIsLoading(false);
//         };
//         fallbackImg.src = fallbackPath;
//       };
//       img.src = path;
//     }
//   }, [visible, baseImagePath]);

//   const renderContent = () => {
//     if (isLoading) {
//       return (
//         <div className="flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
//           <div className="text-center">
//             <ProgressSpinner style={{ width: '50px', height: '50px' }} />
//             <p className="mt-3">Loading...</p>
//           </div>
//         </div>
//       );
//     }

//     if (error) {
//       return (
//         <div className="flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
//           <div className="text-center">
//             <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem', color: '#f44336' }}></i>
//             <p className="mt-3 text-red-500">{error}</p>
//           </div>
//         </div>
//       );
//     }

//     if (imagePath) {
//       return (
//         <div className="flex justify-content-center">
//           <img
//             src={imagePath}
//             alt={title || '圖片'}
//             style={{
//               maxWidth: '100%',
//               maxHeight: '70vh',
//               objectFit: 'contain'
//             }}
//           />
//         </div>
//       );
//     }

//     return null;
//   };

//   const footer = (
//     <div className="flex justify-content-between align-items-center">
//       <div className="flex align-items-center">
//         <Checkbox inputId="dontShowAgain" checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.checked)} />
//         <label htmlFor="dontShowAgain" className="ml-2 cursor-pointer">
//           {t("dontShowAgain")}
//         </label>
//       </div>
//       <Button
//         label={t("button.close")}
//         icon="pi pi-times"
//         onClick={() => {
//           // 把目前的 dontShowAgain 狀態傳給外部
//           if (onDontShowAgain) {
//             onDontShowAgain(dontShowAgain);
//           }
//           onHide();
//         }}
//         className="p-button-text"
//       />
//     </div>
//   );

//   return (
//     <Dialog
//       visible={visible}
//       onHide={onHide}
//       header={title}
//       footer={footer}
//       style={{ width }}
//       closeOnEscape={true}
//       maximizable={false}
//       closable={false}
//       draggable={false}
//     >
//       {renderContent()}
//     </Dialog>
//   );
// };

export default ImageLocaleModal;
